import styled from 'styled-components';

import { hexToRgba } from '@/shared/lib/helpers/hex-to-rgba.helper';
import { Text } from '@/shared/ui/text';

export const SectionTitle = styled(Text)`
	color: ${({ theme }) => hexToRgba(theme.link.color, theme.isDark ? 0.56 : 0.62)};
`;
